import { createAction } from '@reduxjs/toolkit';

const responseError = createAction('api/response-error');

export { responseError };
